import React from 'react';
import { useSelector } from 'react-redux';
import { List } from '../../../../../component/list/list';
import { formatStringCurrency } from '../../../../../shared/utils';
import { Ad, TableHeader } from './types';

interface IAdsInfoModal {
  tableHeader: TableHeader[];
  tableInfo: Ad[];
}

const AdsInfoModal = ({
  tableHeader,
  tableInfo,
}: IAdsInfoModal): JSX.Element => {
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`../../nls/${preference.language.id}.json`);

  const singularOrPluralAge = (age: string): string => {
    if (Number(age) > 1) {
      return 'dias';
    } else {
      return 'dia';
    }
  };
  return (
    <div className="offers-secondary-ads-container">
      <h6>{nls.modalOffersSecondary.adsInfo.title}</h6>
      <div className="offers-secondary-ads-data-container">
        <List
          header={tableHeader}
          data={tableInfo}
          cy={`BuildingModalOffersSecondaryAds`}
          listCustom={(ad) => {
            const itemCustom = ad;
            itemCustom.address = ad?.address;
            itemCustom.value = ad?.price
              ? formatStringCurrency(ad.price.toString())
              : '-';
            itemCustom.value_per_area = ad?.price_m2
              ? formatStringCurrency(ad.price_m2.toString())
              : '-';
            itemCustom.area = ad?.total_area || '-';
            itemCustom.dormitory = ad?.bedrooms || '-';
            itemCustom.suites = ad?.suites || '-';
            itemCustom.garages = ad?.garages || '-';
            itemCustom.ad_age = ad?.ad_duration
              ? `${ad.ad_duration} ${singularOrPluralAge(ad.ad_duration)}`
              : '-';
            itemCustom.link = (
              <a href={ad.url} target="_blank" rel="noreferrer">
                {nls.modalOffersSecondary.adsInfo.link}
              </a>
            );

            return itemCustom;
          }}
          noData={nls.modalOffersSecondary.adsInfo.noData}
        />
      </div>
    </div>
  );
};

export default AdsInfoModal;
